import React from 'react';

import { Grid, Switch } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import { StyledH2 } from 'common/components';

const ProductStatus = ({
    allianceId,
    callback,
    canModify,
    handleChangeProductStatus,
    product,
}) => (
    <Grid alignItems="center" container sx={{ width: '100%' }}>
        <Grid size="grow">
            <StyledH2>{product.name}</StyledH2>
        </Grid>

        <Grid hidden={!canModify}>
            <Switch
                checked={product.approved}
                onChange={() =>
                    handleChangeProductStatus(
                        { allianceId: allianceId, productId: product.id },
                        callback,
                    )
                }
            />
        </Grid>
    </Grid>
);

ProductStatus.propTypes = {
    allianceId: PropTypes.string,
    callback: PropTypes.func,
    canModify: PropTypes.bool,
    handleChangeProductStatus: PropTypes.func,
    product: PropTypes.object,
};

export default ProductStatus;
